import React from "react";
import style from "../PrivacyPolicy/privacypolicy.module.css";

const TermOfService = () => {
  return (
    <div>
      <div className={style.privacyPolicyContainer}>
        <div className="container">
          <div className={style.mainprivacypolicyheading}>
            <div className={style.privacyHeading}>
              {" "}
             Terms of Service 
              <br />{" "}
              {/* <div className={style.subHeading}>
              {" "}
              Site Privacy Policy
            </div> */}
            </div>
          </div>
          <div className="my-5">

            <div className={style.sectionHeading}>Effective Date: <span>February 1, 2026 </span></div>
            <div className={style.sectionsubheading}>
             Welcome to FundLife.me (“FundLife.me,” “FundLife,” “we,” “us,” or “our”). These Terms of Service (“Terms”) govern your access to and use of the FundLife.me website, platform, and related services (collectively, the “Services”). By accessing or using the Services, you agree to these Terms. If you do not agree, please do not use the Services. 
            </div>

          </div>
          <div className="my-5">

            <div className={style.sectioninnerHeading}>
            1. About FundLife.me 
            </div>
            <div className={style.privacyText}>
              FundLife.me is a <b>for-profit technology platform </b> that provides tools for individuals and organizations to create, manage, and share fundraising campaigns. FundLife.me is <b>not a charity</b>, <b>nonprofit organization, bank, or payment processor,</b> and does not solicit donations on its own behalf. 
             
           FundLife.me does not control, guarantee, or verify how funds raised by Organizers are ultimately used. 
            </div>

          </div>

          <div className="my-5">

            <div className={style.sectionHeading}>
             2. Definitions 
            </div>
            <div className={style.privacyText}>
              When you use the Services, limited technical information may be collected automatically, such as:
              <div className={style.privacytextlist}>
                <li>
                  <ul>
                   <b>Account –</b> Your registered profile on FundLife.me 
                  </ul>

                </li>
                <li>
                  <ul>
                    <b>Organizer – </b>A person or organization that creates or manages a fundraising campaign 
                  </ul>

                </li>
                <li>
                  <ul>
                   <b>Donor – </b> A person who contributes funds to a campaign 
                  </ul>
                </li>
                  <li>
                  <ul>
                   <b>Beneficiary – </b> The intended recipient of funds raised
                  </ul>
                </li>
                  <li>
                  <ul>
                   <b>Fundraiser – </b> A campaign created using the Services 
                  </ul>
                </li>
                  <li>
                  <ul>
                   <b>User Content – </b> Any text, images, videos, or other content submitted by users
                  </ul>
                </li>
              </div>
             
            </div>

          </div>
          <div className="my-5">

         <div className={style.sectionHeading}>
             3. Eligibility and Accounts 
           <div className={style.privacyText}>
             You must be at least 18 years old to create an Account or fundraiser. By using the Services, you represent that: 
              <div className={style.privacytextlist}>
                <ul >
                  <li>
                   Information you provide is accurate and current 
                  </li>
                  <li>
                    You are authorized to act on behalf of any organization you represent 
                  </li>
                  <li>
                   You are responsible for all activity under your Account 
                  </li>
                </ul>


              </div>
            You are responsible for maintaining the confidentiality of your login credentials. 
            </div>
            </div>

          </div>
          <div className="my-5">

          <div className={style.sectionHeading}>
            4. Organizer Responsibilities 
           <div className={style.privacyText}>
            As an Organizer, you agree that: 
              <div className={style.privacytextlist}>
                <ul >
                  <li>
                All information in your fundraiser is truthful and not misleading 
                  </li>
                  <li>
                  Funds will be used for the stated purpose 
                  </li>
                  <li>
                   You will comply with all applicable laws and regulations  
                  </li>
                   <li>
              You have permission to share information, images, or stories involving others  
                  </li>
                   
                </ul>


              </div>
             FundLife.me reserves the right to remove or suspend fundraisers that violate these Terms or pose legal, reputational, or safety risks. 
            </div>
            </div>

          </div>
          <div className="my-5">

             <div className={style.sectionHeading}>
            5. Donor Acknowledgment  
           <div className={style.privacyText}>
            By making a contribution, Donors understand that: 
              <div className={style.privacytextlist}>
                <ul >
                  <li>
               Donations are voluntary 
                  </li>
                  <li>
                  FundLife.me does not guarantee outcomes or fund usage 
                  </li>
                  <li>
                  Questions about fund use should be directed to the Organizer   
                  </li>
                  
                </ul>


              </div>
            All donations are made at the Donor’s discretion. 
            </div>
            </div>
          </div>
          <div className="my-5">
  <div className={style.sectionHeading}>
         6. Payments and Fees 
           <div className={style.privacyText}>
            FundLife.me does not process payments directly. Payments are handled by third-party payment processors. By donating or withdrawing funds, you agree to the terms of those processors. 
FundLife.me may charge <b>platform or service fees,</b> which will be disclosed at the time of use. Payment processing fees are determined by the payment processor. 
            </div>
            </div>

          </div>
          <div className="my-5">

            <div className={style.sectionHeading}>7. Platform Role and No Fiduciary Duty </div>
            <div className={style.privacyText}>
FundLife.me provides technology services only. 
We do not act as an escrow agent, trustee, or fiduciary for any user. 
Use of the Services does <b>not </b> create a fiduciary, advisory, or agency relationship between FundLife.me and any user. 
            </div>

          </div>
          <div className="my-5">

             <div className={style.sectionHeading}>
        8. Content Standards 
           <div className={style.privacyText}>
            You may not post content that is: 
              <div className={style.privacytextlist}>
                <ul >
                  <li>
               Illegal, fraudulent, or deceptive 
                  </li>
                  <li>
                 Defamatory, abusive, or discriminatory 
                  </li>
                  <li>
                  Infringing on intellectual property rights  
                  </li>
                   <li>
                 Harmful to minors or others 
                  </li>
                  
                </ul>


              </div>
           FundLife.me may remove content at its discretion to protect platform integrity. 
            </div>
            </div>

          </div>
          <div className="my-5">

            <div className={style.sectionHeading}>
              9. Intellectual Property 
            </div>
            <div className={style.privacyText}>
              All FundLife.me content, software, and branding are owned by or licensed to FundLife.me. You may not copy, reproduce, or distribute platform materials without written permission. 
You grant FundLife.me a non-exclusive, royalty-free license to display and distribute User Content solely for operating the Services. 
            </div>

          </div>
          <div className="my-5">

            <div className={style.sectionHeading}>
             10. Privacy  
            </div>
            <div className={style.privacyText}>
Your use of the Services is subject to the FundLife.me Privacy Policy, which explains how information is collected and used. 
            </div>

          </div>
              <div className="my-5">

             <div className={style.sectionHeading}>
      11. Limitation of Liability 
           <div className={style.privacyText}>
  To the fullest extent permitted by law, FundLife.me shall not be liable for: 
              <div className={style.privacytextlist}>
                <ul >
                  <li>
               Losses related to donations or fund usage 
                  </li>
                  
                  <li>
                Disputes between users   
                  </li>
                   <li>
                Unauthorized access to accounts 
                  </li>
                  <li>
                Indirect, incidental, or consequential damages 
                  </li>
                </ul>


              </div>
           Use of the Services is at your own risk.  
            </div>
            </div>

          </div>
         
          <div className="my-5">

            <div className={style.sectionHeading}>
             12. Termination 
            </div>
            <div className={style.privacyText}>
              FundLife.me may suspend or terminate Accounts or access to the Services at any time, with or without notice, for violations of these Terms or to protect users and the platform. 
           </div>

          </div>

          <div className="my-5">

            <div className={style.sectionHeading}>
            13. Governing Law 
            </div>
            <div className={style.privacyText}>
              These Terms are governed by the laws of the <b>State of Texas,</b> without regard to conflict-of-law rules. 
           </div>

          </div>

          <div className="my-5">

            <div className={style.sectionHeading}>
           14. Changes to These Terms 
            </div>
            <div className={style.privacyText}>
             We may update these Terms from time to time. Continued use of the Services after updates constitutes acceptance of the revised Terms. 
           </div>

          </div>
          
         <div className="my-5">

            <div className={style.sectionHeading}>13. Contact Us  </div>
            <div className={style.privacyTextcontact}>
              <p>For questions regarding these Terms:  </p>
              <b>FundLife.me </b>
              <p>Email: info@Fundlife.me </p>
              <p>Houston, Texas </p>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default TermOfService;
